export default __webpack_public_path__ + "static/media/3-PARENTS.de7cb72d.pdf";